<template>
	<!-- `product-gallery__arrow` is a styling hook (styled in aworldofcraft). -->
	<div
		:class="[
			`product-gallery__arrow ${arrowDirectionStyle}   w-6 h-12 flex items-center absolute z-20  cursor-pointer ${
				arrowDirection === 'bottom'
					? 'rotate-90 right-[50%] translate-x-[50%] bottom-0 bg-white bg-opacity-75'
					: arrowDirection === 'top'
						? '-rotate-90 right-[50%] translate-x-[50%] top-0 bg-white bg-opacity-75'
						: ' '
			} `
		]"
	>
		<ChevronRightIcon :class="[`h-6 w-6 text-primary`]" />
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
	arrowDirection: String
});
const { arrowDirection } = props;

const arrowDirectionStyle = computed(() => {
	return arrowDirection === "left" ? "left-0 rotate-180" : "right-0";
});
</script>
